const messages = {
  tr: {
    register: 'Kayıt',
    join_now: 'Hemen Katılın',
    select_stream_below: 'Lütfen izlemek istediğiniz yayını seçiniz',
    please_write_your_question: 'Lütfen sorunuzu yazın',
    change: 'Değiştir',
    save: 'Kaydet',
    cancel: 'İptal',
    send: 'Gönder',
    sending: 'Gönderiliyor...',
    name: 'Ad Soyad',
    okey: 'Tamam',
    city_or_country: 'Lokasyon',
    please_register: 'Giriş',
    please_wait: 'Lütfen bekleyin',
    please_enter_your_name: 'Soru göndermek için lütfen isminizi ve bulunduğunuz lokasyonu giriniz',
    hide_questions: 'Sorular sadece konuşmacı ve moderatör tarafından görüntülenebilir.',
    add_to_calendar: 'Takvime Ekle',
    livecast_will_start_in: 'Livecast {time} başlayacak',
    form_validation_error: 'Kayıt bilgileri doğrulanamadı',
    registration_form_error: 'Lütfen kayıt formundaki hataları düzeltin.',
    send_question_success: 'Sorularınız gönderildi.',
    send_question_error: 'Soru gönderilirken hata oluştu!',
    required_field_error: 'Bu alan zorunludur.',
    invalid_field_error: 'hatalı {fieldName} formatı',
    regform_selectBoxOther: 'Diğer',
    thanks_for_registering: 'Kayıt olduğunuz için teşekkür ederiz.',
    confirmation_mail_sent: 'Webcast linkini de içeren bir bilgilendirme maili email adresinize gönderilmiştir.',
    join_15_min_before: 'Lütfen etkinlik saatinden 15dk. önce giriş yapınız.'
  }
}

export default messages